module.exports = __webpack_public_path__ + "img/podcast.953575.svg";